import { useQuery } from '@tanstack/react-query';
import { dashboardApi, dashboardQueryKeys } from '../api/dashboard.api';

export function useYearlyPlan(enabled = true) {
  return useQuery({
    queryKey: dashboardQueryKeys.yearlyPlan(),
    queryFn: () => dashboardApi.getYearlyPlan(),
    enabled,
  });
}
